<template>
  <div class="g-navbar">
    <h1 class="g-navbar-title" v-if="title && !$slots.center">
      <span class="g-navbar-text" v-text="title"></span>
    </h1>
    <div class="g-navbar-left" v-if="$slots.left">
      <slot name="left" />
    </div>
    <div class="g-navbar-center" v-if="$slots.center">
      <slot name="center" />
    </div>
    <div class="g-navbar-right" v-if="$slots.right">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CNavbar',
    props: {
      title: {
        type: String,
        default: '',
      },
    },
  };
</script>
